import { render, staticRenderFns } from "./NewTodoForm.vue?vue&type=template&id=3cc96f39&scoped=true"
import script from "./NewTodoForm.vue?vue&type=script&lang=js"
export * from "./NewTodoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc96f39",
  null
  
)

export default component.exports